@if(loader){
<app-loader></app-loader>
}
<p-card header="Create Menu">
    <div class="field col-12 flex justify-content-between align-items-center">
        <div class="flex">
            <div>
                <p-button label="Save" (onClick)="createMenu()" class="p-button-outlined ml-2 " icon="pi pi-save"
                    size="small"></p-button>
            </div>
            <div>
                <p-button label="Reset" (onClick)="reset()" class="p-button-outlined ml-2 " icon="pi pi-replay"
                    severity="info" size="small"></p-button>
            </div>
            <div>
                <p-button label="Cancel" (onClick)="cancel()" class="p-button-outlined ml-2" icon="pi pi-times"
                    severity="danger" size="small"></p-button>
            </div>
        </div>
        <div>
            <label class="block label-required" style="font-weight: bold;">Required Field</label>
        </div>
    </div>

    <form [formGroup]="menuForm" style="height: 30vh">
        <div class="grid mt-5">
            <div class="col mt-3">
                <div class="field text-left">
                    <p-checkbox label="Menus Existed" value="true" [binary]="true"
                        formControlName="isMenuDropdown"></p-checkbox>
                </div>
            </div>

            @if(menuForm.controls.isMenuDropdown.value){
            <div class="col">
                <div class="field text-left">
                    <label for="Menu" class="label-required display">Menu</label>
                    <p-dropdown [options]="menuOptions" (onChange)="setMenu($event)"
                        formControlName="selectMenuDropdown" value optionLabel="name" placeholder="Select Menu"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && !menuForm.controls.Menu.value}"
                        class="w-full mb-3" styleClass="w-full mb-3"></p-dropdown>
                </div>
            </div>
            }@else {
            <div class="col">
                <div class="field text-left ">
                    <label for="Menu" class="label-required display">Menu</label>
                    <input pInputText formControlName="Menu" class="w-full p-inputtext-sm" placeholder="Add Menu"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && !menuForm.controls.Menu.value}"
                        (keydown)="onKeydown($event)" />
                </div>
            </div>
            }

            <div class="col">
                <div class="field text-left ">
                    <label for="Menu" class="label-required display">Sub Menu</label> 
                    <input pInputText formControlName="subMenu" class="w-full p-inputtext-sm" placeholder="Add Sub Menu"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && !menuForm.controls.subMenu.value}"
                        (keydown)="onKeydown($event)" />
                </div>
            </div>

        </div>
    </form>
</p-card>

<p-toast></p-toast>